/**
 * @file 端外回流唤起App
 * @author yanyiting <yanyiting@baidu.com>
 */

import versionCompare from '@baidu/xbox/version_compare';
import {isIOS, isAndroid, getOSVersion} from '@baidu/xbox/os';

const UA = window.navigator.userAgent;

/**
 * 唤起核心
 *
 * @param {string} scheme 唤起协议
 * @param {Function} failCb 失败处理函数
 * @param {number} waitTime 唤起等待时间
 */
function invoke(scheme, failCb, waitTime) {
    // ios系统版本大于9 或者 安卓chrome
    if ((isIOS() && versionCompare(getOSVersion(), '9.0') >= 0)
        || (isAndroid() && /\bChrome\//i.test(UA)
            && getChromeVersion() > 55 && UA.indexOf('haokan') < 0 && UA.indexOf('bdminivideo') < 0)) {
        // 直接跳转scheme
        window.location.href = scheme;
    }
    // 其他情况使用iframe方式
    else {
        let $node = document.createElement('iframe');
        $node.style.display = 'none';
        $node.src = scheme;
        let body = document.body || document.getElementsByTagName('body')[0];
        body.appendChild($node);
        setTimeout(() => {
            body.removeChild($node);
            $node = null;
        }, 10000);
    }

    // 记录起始时间
    let last = +Date.now();
    const timer = setTimeout(() => {
        if (Date.now() - last < waitTime + 200) {
            // 将 scheme 传递给使用方
            failCb(scheme);
        }
    }, waitTime);

    onWebviewResume({
        hiddenCb: () => {
            clearTimeout(timer);
        }
    });
}

/**
 * 端外回流唤起App
 *
 * @return {number} 版本号
 */
function getChromeVersion() {
    let a = UA.split('Chrome/')[1];
    if (!a) {
        return 0;
    }
    let b = a.split('.')[0];
    let c = parseInt(b, 10);
    return c;
}

/**
 * 视图是否可见
 *
 * @param {Object} options 回调
 * @param {Function} options.showCb 页面可见回调
 * @param {Function} options.hiddenCb 及不可见回调
 */
function onWebviewResume({showCb, hiddenCb}) {
    let hidden = 'hidden';
    const handlerFn = () => {
        if (document.visibilityState === 'visible') {
            showCb && showCb();
        } else {
            hiddenCb && hiddenCb();
        }
    };
    // safari 7 和其他现代浏览器生效
    if (hidden in document) {
        document.addEventListener('visibilitychange', handlerFn);
    }
    // android 4.4及以上生效
    else if ((hidden = 'webkitHidden') in document) {
        document.addEventListener('webkitvisibilitychange', handlerFn);
    }
    else {
        window.addEventListener('pagehide', hiddenCb);
    }
}

/**
 * 端外回流唤起App
 *
 * @param {Object} options 配置项
 * @param {string} options.scheme 唤起协议
 * @param {Function} options.failCb 失败处理函数
 * @param {number} options.waitTime 唤起等待时间
 */
module.exports = ({scheme, failCb, waitTime = 0}) => {
    if (scheme) {
        invoke(scheme, failCb, waitTime);
    }
    else {
        failCb();
    }
};
